import React from 'react';
import styles from './Toggle.module.scss';

const Switch = ({ currentSetting, allowedCookies, setAllowedCookies }:any) => {
  const onToggleHandle = () => {
    setAllowedCookies((prev:any) => ({
      ...prev,
      [currentSetting]: !allowedCookies[currentSetting],
    }));
  };

  return (
    <>
      <input
        checked={allowedCookies[currentSetting]}
        className={styles.reactSwitchCheckbox}
        id={'react-switch-new'}
        onChange={onToggleHandle}
        type={'checkbox'}
      />
      <label
        className={styles.reactSwitchLabel}
        htmlFor={'react-switch-new'}
        style={{ background: allowedCookies[currentSetting] ? '#00927C' : '' }}
      >
        <span className={styles.reactSwitchButton} />
      </label>
    </>
  );
};

export default Switch;
